
import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";

const ToastContext = createContext(null);

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "success") => {
    const id = `${Date.now()}-${Math.random()}`;

    // Add a new toast without replacing existing toasts
    setToasts((prev) => [...prev, { id, message, type }]);

    // Remove only this toast after 3 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, 3000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      <div className="rtx-toast-container">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

/* ===============================
   TOAST UI
================================ */
const Toast = ({ message, type }) => {
  return (
    <div className={`rtx-toast rtx-toast-${type}`}>
      {message}
    </div>
  );
};
